<template>
  <div class="coinExchangeSkeleton">
    <div class="coinExchangeSkeleton__coin">
      <pseudo-skeleton width="60%" height="20px" border-radius="100px" />
      <div class="flex justify-end">
        <pseudo-skeleton width="40%" height="20px" border-radius="100px" />
      </div>
      <pseudo-skeleton width="40%" height="20px" border-radius="100px" />
      <div class="coin-dropdown-skeleton">
        <base-skeleton width="20px" height="20px" border-radius="100%" />
        <base-skeleton width="40%" height="14px" border-radius="100px" />
      </div>
    </div>
    <div class="coinExchangeSkeleton__swap">
      <svg-icon class="coinExchangeSkeleton__swap__icon" name="swap" />
    </div>
    <div class="coinExchangeSkeleton__coin">
      <pseudo-skeleton width="60%" height="20px" border-radius="100px" />
      <div class="flex justify-end">
        <pseudo-skeleton width="40%" height="20px" border-radius="100px" />
      </div>
      <pseudo-skeleton width="40%" height="20px" border-radius="100px" />
      <div class="coin-dropdown-skeleton">
        <base-skeleton width="20px" height="20px" border-radius="100%" />
        <base-skeleton width="40%" height="14px" border-radius="100px" />
      </div>
    </div>
  </div>
</template>

<script>
import PseudoSkeleton from '@/shared/ui/PseudoSkeleton/PseudoSkeleton.vue'
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'
import BaseSkeleton from '@/shared/ui/BaseSkeleton/BaseSkeleton.vue'

export default {
  components: {
    BaseSkeleton,
    PseudoSkeleton,
    SvgIcon,
  },
}
</script>

<style scoped lang="scss">
.coinExchangeSkeleton {
  position: relative;
  display: grid;
  gap: 5px;
  margin-bottom: 15px;

  &__coin {
    height: 120px;
    background-color: var(--bg-1);
    border: 1px solid var(--bg-35);
    border-radius: 12px;
    padding: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem;
  }

  &__swap {
    width: 36px;
    height: 36px;
    background-color: var(--brand);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: var(--bg-2);

    &__icon {
      width: 26px;
      height: 26px;
    }
  }

  &__swap:hover {
    background-color: var(--brand-hover);
  }
}

@media (max-width: 768px) {
  .coinExchangeSkeleton {
    &__swap {
      left: 90%;
    }
  }
}

.coin-dropdown-skeleton {
  justify-self: right;
  align-self: center;
  width: 100px;
  height: 36px;
  padding-left: 10px;
  background-color: #1a1a1a;
  border-radius: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
}
</style>
